import Subtasks from './Subtasks';

interface Props {
  toggleDropdown: () => void;
}
const QueueDropdown: React.FC<Props> = ({ toggleDropdown }) => {
  return (
    <div
      onMouseLeave={toggleDropdown}
      className="absolute z-10 flex w-full flex-col gap-y-2 rounded border border-gray-300 bg-white p-2 shadow-lg"
    >
      <ul className="custom-scroll flex max-h-72 flex-col gap-y-1 overflow-auto p-2 font-inter text-sm">
        <Subtasks />
      </ul>
    </div>
  );
};

export default QueueDropdown;
